var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMirage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 69",
    fill: "currentColor",
    width: 64,
    height: 64,
    className: "w-8 sm:w-10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 46.081a2 2 0 012-2h74.724a2 2 0 110 4H2a2 2 0 01-2-2zM15.35 56.081c0-1.103.893-1.997 1.996-1.997h44.031a1.997 1.997 0 010 3.994H17.346a1.997 1.997 0 01-1.997-1.997zM30.694 66.081a2 2 0 012-2h13.335a2 2 0 010 4H32.694a2 2 0 01-2-2z",
    fill: "#05C77E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.736 14.254a2 2 0 011.67 1.021L70.12 45.103a2 2 0 11-3.49 1.956L51.517 20.087l-7.785 11.725A2 2 0 0140.4 29.6l9.595-14.453a2 2 0 011.741-.893z",
    fill: "#05C77E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.661.125c7.183 0 13.006 5.823 13.006 13.006 0 5.638-3.587 10.438-8.604 12.242l-1.869-3.337a9.26 9.26 0 006.723-8.905 9.256 9.256 0 10-18.512 0c0 2.207.772 4.233 2.062 5.824l-2.144 3.23a12.963 12.963 0 01-3.668-9.054c0-7.183 5.823-13.006 13.006-13.006z",
    fill: "#05C77E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.522 9.868a2 2 0 011.74.906l22.33 34.214a2 2 0 01-3.349 2.186L29.715 15.721l-17.624 31.34a2 2 0 01-3.486-1.96l19.24-34.214a2 2 0 011.677-1.019z",
    fill: "#05C77E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirage);
export default __webpack_public_path__ + "static/media/mirage.d19a51109a1a0ed5a31227c9a92c8e1d.svg";
export { ForwardRef as ReactComponent };